import React, { useEffect } from 'react';

const ShowPaytmPaymentPage = ({ txnToken, mIdToken=null }) => {
    const orderId = sessionStorage.getItem('linkId');
    const mId = mIdToken ? mIdToken : sessionStorage.getItem('mId');
    const url = `${process.env.REACT_APP_PAYTM_BASE_URL}?mid=${mId}&orderId=${orderId}`;

    useEffect(() => {
        document.getElementById('paytm').submit();
    }, []);

    return (
        <div>
            <center>
                <h1>Please do not refresh this page...</h1>
            </center>
            <form method="post" id="paytm" action={url} name="paytm">
                <input type="hidden" name="mid" value={mId} />
                <input type="hidden" name="orderId" value={orderId} />
                <input type="hidden" name="txnToken" value={txnToken} />
            </form>
        </div>
    );
};

export default ShowPaytmPaymentPage;
